export default __webpack_public_path__ + "static/nbaa-d547064181398aa66366e6ef243a4c7c.png";